import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Container, Typography, Grid, useTheme, alpha } from '@mui/material';
import { CalendarMonth, AttachMoney, WarningAmber, PeopleAlt, AccessTime, } from '@mui/icons-material';
import { SectionBox } from './sectionBox';
import { SectionHeader } from './sectionHeader';
import { CtaButton } from './ctaButton';
const iconMap = {
    calendar: CalendarMonth,
    dollar: AttachMoney,
    warning: WarningAmber,
    people: PeopleAlt,
    clock: AccessTime,
};
export const CostOfHiringSection = ({ label, title, subtitle, footnote, cards, fixCard, }) => {
    const theme = useTheme();
    return (_jsx(SectionBox, { id: "pain-points", children: _jsxs(Container, { maxWidth: "lg", children: [_jsx(SectionHeader, { label: label, title: title, subtitle: subtitle, footnote: footnote }), _jsxs(Grid, { container: true, spacing: 4, children: [cards.map((card, index) => {
                            const IconComponent = iconMap[card.icon];
                            return (_jsx(Grid, { size: { xs: 12, sm: 6, md: 4 }, children: _jsxs(Box, { sx: {
                                        p: { xs: 4, md: 5 },
                                        borderRadius: '12px',
                                        border: `1px solid ${theme.palette.divider}`,
                                        backgroundColor: theme.palette.background.paper,
                                        height: '100%',
                                        display: 'flex',
                                        flexDirection: 'column',
                                    }, children: [_jsx(Box, { sx: {
                                                width: 40,
                                                height: 40,
                                                borderRadius: '10px',
                                                backgroundColor: alpha(theme.palette.error.main, 0.1),
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                mb: 3,
                                            }, children: _jsx(IconComponent, { sx: { fontSize: 22, color: theme.palette.error.main } }) }), _jsx(Typography, { sx: {
                                                fontSize: { xs: '20px', md: '24px' },
                                                fontWeight: 700,
                                                color: theme.palette.text.primary,
                                                mb: 1,
                                            }, children: card.value }), _jsx(Typography, { sx: {
                                                fontSize: '14px',
                                                fontWeight: 600,
                                                color: theme.palette.text.secondary,
                                                mb: 2,
                                            }, children: card.tag }), _jsx(Typography, { sx: {
                                                fontSize: '14px',
                                                color: theme.palette.text.secondary,
                                                lineHeight: 1.6,
                                            }, children: card.description })] }) }, index));
                        }), _jsx(Grid, { size: { xs: 12, sm: 6, md: 4 }, children: _jsxs(Box, { sx: {
                                    p: { xs: 4, md: 5 },
                                    borderRadius: '12px',
                                    backgroundColor: theme.palette.primary.main,
                                    color: '#fff',
                                    height: '100%',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'center',
                                }, children: [_jsx(Typography, { sx: {
                                            fontSize: '11px',
                                            fontWeight: 600,
                                            letterSpacing: '0.05em',
                                            color: '#fff',
                                            mb: 2,
                                        }, children: fixCard.label }), _jsx(Typography, { sx: {
                                            fontSize: { xs: '20px', md: '24px' },
                                            fontWeight: 700,
                                            color: '#fff',
                                            mb: 2,
                                            lineHeight: 1.3,
                                        }, children: fixCard.title }), _jsx(Typography, { sx: {
                                            fontSize: '14px',
                                            color: 'rgba(255,255,255,0.92)',
                                            lineHeight: 1.6,
                                            mb: 4,
                                        }, children: fixCard.description }), _jsx(CtaButton, { href: fixCard.ctaHref, variant: "outlined", size: "medium", sx: {
                                            color: '#fff',
                                            borderColor: 'rgba(255,255,255,0.5)',
                                            '&:hover': {
                                                borderColor: '#fff',
                                                backgroundColor: 'rgba(255,255,255,0.1)',
                                            },
                                            alignSelf: 'flex-start',
                                        }, children: fixCard.ctaText })] }) })] })] }) }));
};
